var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c("icon", {
        staticClass: "text-danger clickable",
        class: { "error-icon": _vm.shake },
        attrs: { id: _vm.id, name: "exclamation-circle" },
      }),
      _vm._v(" "),
      _c("notification-popover", {
        ref: "popover",
        attrs: {
          target: _vm.id,
          "keep-open": !!_vm.showErrors && _vm.isFirstItem && !_vm.noTooltip,
        },
        scopedSlots: _vm._u([
          {
            key: "popoverContent",
            fn: function () {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t(
                        "application-standalone.pages.pleaseReviewThisSection"
                      )
                    ) +
                    "\n    "
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }